import React, { Component } from "react";
import LoadingPanel from "../../common/LoadingPanel";
import { toolsController } from "../../../controllers/tools.controller";
import confirmService from "../../common/confirmService";

class KontrolaProdejnyDialogContent extends Component {
    state = {
        result: null,
        loading: true
    };

    componentDidMount() {
        toolsController.kontrolaNastaveniaPredajne().then(async (response) => {
            if (response.errorMessage) {
                await confirmService.show({
                    type: response.messageType,
                    message: response.errorMessage,
                    logMessage: true
                });
            }
            this.setState({
                result: response,
                loading: false
            });
        });
    }

    renderDialogContent() {
        return (
            <div id="KontrolaProdejnyDialog">
                <p>
                    Kontrola existencie užívateľa <strong>Jaro</strong>:{" "}
                    {this.state.result.existsUzivatelJaro ? <span className="color-green">OK</span> : <span className="color-red">Chýba</span>}
                </p>
                <p>
                    Kontrola existencie nastavenia <strong>241 - číslo posledného balíka</strong>:{" "}
                    {this.state.result.existsNastaveniePoslBalikCislo ? <span className="color-green">OK</span> : <span className="color-red">Chýba</span>}
                    {this.state.result.existsNastaveniePoslBalikCislo && this.state.result.nastavenieHodnotaPoslBalikCislo ? (
                        <React.Fragment>
                            <br />
                            Hodnota nastavenia = <span className="color-green">{this.state.result.nastavenieHodnotaPoslBalikCislo}</span>
                        </React.Fragment>
                    ) : (
                        <React.Fragment />
                    )}
                </p>
                <p>
                    Kontrola existencie nastavenia <strong>242 - séria posledného balíka</strong>:{" "}
                    {this.state.result.existsNastaveniePoslBalikSeria ? <span className="color-green">OK</span> : <span className="color-red">Chýba</span>}
                    {this.state.result.existsNastaveniePoslBalikSeria && this.state.result.nastavenieHodnotaPoslBalikSeria ? (
                        <React.Fragment>
                            <br />
                            Hodnota nastavenia = <span className="color-green">{this.state.result.nastavenieHodnotaPoslBalikSeria}</span>
                        </React.Fragment>
                    ) : (
                        <React.Fragment />
                    )}
                </p>
                <p>
                    Kontrola existencie nastavenia <strong>395 - znovu nahlasované dodávky</strong>:{" "}
                    {this.state.result.existsNastavenieZnovuNahlasovaneDodavky ? (
                        <span className="color-green">OK</span>
                    ) : (
                        <span className="color-red">Chýba</span>
                    )}
                    {this.state.result.existsNastavenieZnovuNahlasovaneDodavky && this.state.result.nastavenieHodnotaZnovuNahlasovaneDodavky ? (
                        <React.Fragment>
                            <br />
                            Hodnota nastavenia = <span className="color-green">{this.state.result.nastavenieHodnotaZnovuNahlasovaneDodavky}</span>
                        </React.Fragment>
                    ) : (
                        <React.Fragment />
                    )}
                </p>
                <p>
                    Kontrola existencie správy typu <strong>Avízo</strong>:{" "}
                    {this.state.result.existsSpravaAvizo ? <span className="color-green">OK</span> : <span className="color-red">Chýba</span>}
                </p>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderDialogContent();

        return <div>{contents}</div>;
    }
}

export default KontrolaProdejnyDialogContent;



// WEBPACK FOOTER //
// ./src/components/views/Tools/KontrolaProdejnyDialogContent.js